import CredentialMessagingConnectionCard from "./CredentialMessagingConnectionCard";
import { LineIcon } from "./BrandIcons";

export default function LineConnectionCard({ className }: { className?: string }) {
  return (
    <CredentialMessagingConnectionCard
      className={className}
      channelName="LINE"
      functionName="line-onboard"
      queryKey="lineConnection"
      Icon={LineIcon}
      iconBackground="rgba(6, 199, 85, 0.10)"
      disconnectedDescription="Connect your LINE Official Account so Dibs can reply to customers."
      connectedDescription="Dibs replies to customers who message your LINE Official Account."
      healthChannel="line"
      dialogDescription="Dibs validates the Messaging API channel and stores both credentials encrypted."
      fields={[
        {
          key: "channelSecret",
          label: "Channel secret",
          placeholder: "From Basic settings",
          secret: true,
        },
        {
          key: "channelAccessToken",
          label: "Channel access token",
          placeholder: "From Messaging API settings",
          secret: true,
          help: "Use a long-lived channel access token.",
        },
      ]}
      instructions={
        <ol className="list-decimal space-y-1 pl-5">
          <li>Create or open a LINE Official Account with a Messaging API channel.</li>
          <li>Copy the channel secret and issue a long-lived channel access token.</li>
          <li>After connecting, copy the webhook URL shown here into LINE Developers and enable webhooks.</li>
        </ol>
      }
      connectedLabel={(state) =>
        typeof state.display_name === "string" && state.display_name
          ? `Connected as ${state.display_name}`
          : "LINE Official Account connected"}
      connectedDetails={(state) => (
        <>
          <p>
            <span className="text-muted-foreground">Official Account: </span>
            {String(state.display_name ?? "Connected")}
            {state.basic_id ? ` (${String(state.basic_id)})` : ""}
          </p>
          <p className="text-xs text-muted-foreground">
            Paste the webhook URL below into the LINE Developers console, turn
            on “Use webhook”, and run LINE's Verify test.
          </p>
        </>
      )}
    />
  );
}
